// import axios from 'axios';
// import toast from 'react-hot-toast';

// // Helper function for GET requests without authentication
// export const getAxios = async ({ url }) => {
//     try {
//         let response = await axios.get(url);

//         if (response.status === 200) {
//             if (response.data.status === 201 || response.data.status === 200) {
//                 return response.data;
//             } else if (response.data.status === 400) {
//                 toast.error(`${Object.entries(response.data.data)[0][0]}, ${Object.entries(response.data.data)[0][1]}`);
//                 return null;
//             } else if (response.data.status === 204) {
//                 toast.error(response.data.message);
//                 return null;
//             } else if (response.data.status === 404 || response.status === 404) {
//                 toast.error(response.data.message || response.message);
//                 return null;
//             } else {
//                 toast.error(response.message);
//                 return null;
//             }
//         } else {
//             toast.error(response.message);
//             return null;
//         }
//     } catch (err) {
//         if (err.code === 'ERR_NETWORK') {
//             return 'ERR_NETWORK';
//         }
//         if (err.response && err.response.status === 401) {
//             localStorage.setItem('is_authenticated', false);
//             localStorage.removeItem('login');
//         } else {
//             toast.error(err.message);
//         }
//         return null;
//     }
// };

// // GET request with token authentication
// export const getAxiosWithToken = async ({ url }) => {
//     const token = JSON.parse(localStorage.getItem('login'))?.token;

//     if (!token) {
//         console.error('❌ Token not found. Please login again.');
//         return;
//     }

//     try {
//         const response = await axios.get(url, {
//             headers: {
//                 'Authorization': `Token ${token}`,
//                 'Content-Type': 'application/json',
//             },
//         });

//         if (response.status === 200) {
//             return response.data;
//         } else {
//             console.error('❌ Something went wrong');
//             return null;
//         }
//     } catch (err) {
//         if (err.response && err.response.status === 401) {
//             sessionStorage.removeItem('auth_token');
//             console.error('❌ Session expired, please log in again.');
//         } else {
//             console.error('❌ Error occurred:', err.message);
//         }
//     }
// };

// // POST request with token authentication
// export const postAxios = async ({ url, body, requireAuth = false }) => {
//     try {
//         let headers = { 'Content-Type': 'application/json' };

//         if (requireAuth) {
//             const token = sessionStorage.getItem('auth_token') || localStorage.getItem('auth_token');
//             if (token) {
//                 headers['Authorization'] = `Token ${token}`;
//             } else {
//                 throw new Error("Authentication token is missing");
//             }
//         }

//         const response = await axios.post(url, body, { headers });

//         console.log("📢 Axios Response:", response.data); // Debug Response
//         return response.data;  // ✅ Ensure only response.data is returned
        
//     } catch (error) {
//         console.error('🚨 Axios error:', error);
//         throw error;
//     }
// };






// // POST request with token authentication (using localStorage for token)
// export const postAxiosWithToken = async ({ url, body }) => {
//     const token = JSON.parse(localStorage.getItem('login'))?.token;

//     if (!token) {
//         toast.error('Token not found, please login first.');
//         return null;
//     }

//     try {
//         let response = await axios.post(url, body, {
//             headers: {
//                 'Authorization': `Token ${token}`,
//                 'Content-Type': 'application/json',
//             },
//         });

//         if (response.status === 200) {
//             return response.data;
//         } else {
//             toast.error(response.message || 'Something went wrong');
//             return null;
//         }
//     } catch (err) {
//         if (err.response && err.response.status === 401) {
//             localStorage.removeItem('login');
//             toast.error('Session expired, please log in again.');
//         } else {
//             toast.error(err.message || 'An error occurred');
//         }
//         return null;
//     }
// };

// // POST request with form data (with token)
// export const postAxiosFormWithToken = async ({ url, body }) => {
//     const loginData = localStorage.getItem('login');
//     const token = loginData ? JSON.parse(loginData).token : null;

//     try {
//         let response = await axios.post(url, body, {
//             headers: {
//                 'Authorization': `Token ${token}`,
//                 'Content-Type': 'application/json',
//             },
//         });

//         if (response.status === 200) {
//             return response.data;
//         } else {
//             toast.error(response.message || 'Something went wrong');
//             return null;
//         }
//     } catch (err) {
//         if (err.response && err.response.status === 401) {
//             localStorage.setItem('is_authenticated', false);
//             localStorage.removeItem('login');
//         } else {
//             toast.error(err.message);
//         }
//         return null;
//     }
// };

// // DELETE request with token authentication
// export const deleteAxiosWithToken = async ({ url }) => {
//     const token = JSON.parse(localStorage.getItem('login'))?.token;

//     if (!token) {
//         toast.error('Token not found, please login first.');
//         return null;
//     }

//     try {
//         let response = await axios.delete(url, {
//             headers: {
//                 'Authorization': `Token ${token}`,
//                 'Content-Type': 'application/json',
//             },
//         });

//         if (response.status === 200) {
//             return response.data;
//         } else {
//             toast.error(response.message || 'Something went wrong');
//             return null;
//         }
//     } catch (err) {
//         if (err.response && err.response.status === 401) {
//             localStorage.removeItem('login');
//             toast.error('Session expired, please log in again.');
//         } else {
//             toast.error(err.message || 'An error occurred');
//         }
//         return null;
//     }
// };

// // PUT request with token authentication
// export const putAxiosWithToken = async ({ url, body }) => {
//     const token = JSON.parse(localStorage.getItem('login'))?.token;

//     if (!token) {
//         toast.error('Token not found, please login first.');
//         return null;
//     }

//     try {
//         let response = await axios.put(url, body, {
//             headers: {
//                 'Authorization': `Token ${token}`,
//                 'Content-Type': 'application/json',
//             },
//         });

//         if (response.status === 200) {
//             return response.data;
//         } else {
//             toast.error(response.message || 'Something went wrong');
//             return null;
//         }
//     } catch (err) {
//         if (err.response && err.response.status === 401) {
//             localStorage.removeItem('login');
//             toast.error('Session expired, please log in again.');
//         } else {
//             toast.error(err.message || 'An error occurred');
//         }
//         return null;
//     }
// };







import axios from 'axios';
import toast from 'react-hot-toast';

// remove any accidental global default Content-Type that might break FormData uploads
try {
  if (axios && axios.defaults && axios.defaults.headers && axios.defaults.headers.common) {
    delete axios.defaults.headers.common['Content-Type'];
  }
} catch (e) {
  // ignore
}

// Helper function for GET requests without authentication
export const getAxios = async ({ url }) => {
    try {
        let response = await axios.get(url);

        if (response.status === 200) {
            if (response.data.status === 201 || response.data.status === 200) {
                return response.data;
            } else if (response.data.status === 400) {
                toast.error(`${Object.entries(response.data.data)[0][0]}, ${Object.entries(response.data.data)[0][1]}`);
                return null;
            } else if (response.data.status === 204) {
                toast.error(response.data.message);
                return null;
            } else if (response.data.status === 404 || response.status === 404) {
                toast.error(response.data.message || response.message);
                return null;
            } else {
                toast.error(response.message);
                return null;
            }
        } else {
            toast.error(response.message);
            return null;
        }
    } catch (err) {
        if (err.code === 'ERR_NETWORK') {
            return 'ERR_NETWORK';
        }
        if (err.response && err.response.status === 401) {
            localStorage.setItem('is_authenticated', false);
            localStorage.removeItem('login');
        } else {
            toast.error(err.message);
        }
        return null;
    }
};

let isRedirectingToLogin = false;

const handleSessionExpiry = (msg = 'Session expired, please log in again.') => {
    localStorage.removeItem('login');
    localStorage.setItem('is_authenticated', 'false');
    if (!isRedirectingToLogin) {
        isRedirectingToLogin = true;
        toast.error(msg);
        setTimeout(() => {
            if (window.location.pathname !== '/login' && window.location.pathname !== '/auth/login') {
                window.location.href = '/login';
            }
            isRedirectingToLogin = false;
        }, 1000);
    }
};

// GET request with token authentication
export const getAxiosWithToken = async ({ url }) => {
    const token = JSON.parse(localStorage.getItem('login'))?.token;

    if (!token) {
        handleSessionExpiry('Token not found, please login first.');
        return null;
    }

    try {
        const response = await axios.get(url, {
            headers: {
                'Authorization': `Token ${token}`,
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 200) {
            return response.data;
        } else {
            console.error('❌ Something went wrong');
            return null;
        }
    } catch (err) {
        if (err.response && err.response.status === 401) {
            handleSessionExpiry('Session expired, please log in again.');
        } else {
            console.error('❌ Error occurred:', err.message);
        }
        return null;
    }
};

// POST request with token authentication (JSON)
export const postAxios = async ({ url, body, requireAuth = false }) => {
    try {
        let headers = { 'Content-Type': 'application/json' };

        if (requireAuth) {
            const token = sessionStorage.getItem('auth_token') || localStorage.getItem('auth_token');
            if (token) {
                headers['Authorization'] = `Token ${token}`;
            } else {
                throw new Error("Authentication token is missing");
            }
        }

        const response = await axios.post(url, body, { headers });

        console.log("📢 Axios Response:", response.data); // Debug Response
        return response.data;  // ✅ Ensure only response.data is returned
        
    } catch (error) {
        console.error('🚨 Axios error:', error);
        throw error;
    }
};

// POST request with token authentication (using localStorage for token) — JSON
export const postAxiosWithToken = async ({ url, body }) => {
    const token = JSON.parse(localStorage.getItem('login'))?.token;

    if (!token) {
        handleSessionExpiry('Token not found, please login first.');
        return null;
    }

    try {
        let response = await axios.post(url, body, {
            headers: {
                'Authorization': `Token ${token}`,
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 200) {
            return response.data;
        } else {
            toast.error(response.message || 'Something went wrong');
            return null;
        }
    } catch (err) {
        if (err.response && err.response.status === 401) {
            handleSessionExpiry('Session expired, please log in again.');
        } else {
            toast.error(err.message || 'An error occurred');
        }
        return null;
    }
};

// POST request with form data (with token)
// IMPORTANT: do NOT set 'Content-Type' here — allow browser/axios to set boundary automatically
export const postAxiosFormWithToken = async ({ url, body }) => {
    const loginData = localStorage.getItem('login');
    const token = loginData ? JSON.parse(loginData).token : null;

    if (!token) {
        handleSessionExpiry('Token not found, please login first.');
        return null;
    }

    try {
        // debug: log FormData keys (remove in production)
        if (typeof FormData !== 'undefined' && body instanceof FormData) {
            try {
                console.log("postAxiosFormWithToken: FormData entries:");
                for (const pair of body.entries()) {
                    if (pair[1] instanceof File) console.log(pair[0], pair[1].name, pair[1].size);
                    else console.log(pair[0], pair[1]);
                }
            } catch (e) {
                // ignore
            }
        }

        let response = await axios.post(url, body, {
            headers: {
                'Authorization': `Token ${token}`,
            },
        });

        if (response.status === 200) {
            return response.data;
        } else {
            toast.error(response.message || 'Something went wrong');
            return null;
        }
    } catch (err) {
        if (err.response && err.response.status === 401) {
            handleSessionExpiry('Session expired, please log in again.');
        } else {
            toast.error(err.message);
        }
        return null;
    }
};

// DELETE request with token authentication
export const deleteAxiosWithToken = async ({ url }) => {
    const token = JSON.parse(localStorage.getItem('login'))?.token;

    if (!token) {
        handleSessionExpiry('Token not found, please login first.');
        return null;
    }

    try {
        let response = await axios.delete(url, {
            headers: {
                'Authorization': `Token ${token}`,
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 200) {
            return response.data;
        } else {
            toast.error(response.message || 'Something went wrong');
            return null;
        }
    } catch (err) {
        if (err.response && err.response.status === 401) {
            handleSessionExpiry('Session expired, please log in again.');
        } else {
            toast.error(err.message || 'An error occurred');
        }
        return null;
    }
};

// PUT request with token authentication
export const putAxiosWithToken = async ({ url, body }) => {
    const token = JSON.parse(localStorage.getItem('login'))?.token;

    if (!token) {
        handleSessionExpiry('Token not found, please login first.');
        return null;
    }

    try {
        let response = await axios.put(url, body, {
            headers: {
                'Authorization': `Token ${token}`,
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 200) {
            return response.data;
        } else {
            toast.error(response.message || 'Something went wrong');
            return null;
        }
    } catch (err) {
        if (err.response && err.response.status === 401) {
            handleSessionExpiry('Session expired, please log in again.');
        } else {
            toast.error(err.message || 'An error occurred');
        }
        return null;
    }
};
